export type ErrorLabelProps = {
  error?: string;
}

export const ErrorLabel = ({ error }: ErrorLabelProps) => {
  return (
    <>
      { error && <span className="text-red-500 ml-1">{error}</span> }
    </>
  )
};
